import { useEffect, useState } from 'react';
import axiosInstance from '../../../Services/axios';

/**
 * Fetches active units from the API for a given PCR type ('price' or 'size').
 * Returns { units, defaultUnit } — always populated (falls back to hardcoded list).
 */
export const useUnitOptions = (type, fallback) => {
    const [units, setUnits] = useState(fallback);
    const [defaultUnit, setDefaultUnit] = useState(fallback[0]);

    useEffect(() => {
        axiosInstance
            .get(`/admin/pcr-units?type=${type}`)
            .then((response) => {
                const list = response.data.map((unit) => unit.value);
                if (!list.length) return;
                const defaultUnit =
                    response.data.find((unit) => unit.is_default)?.value ??
                    list[0];
                setUnits(list);
                setDefaultUnit(defaultUnit);
            })
            .catch(() => {
                /* keep fallback */
            });
    }, [type]);

    return { units, defaultUnit };
};

/**
 * Parses a stored "amount unit" string into its parts.
 * If the tail after the last space is not a known unit, returns the whole string as amount.
 */
export const parseAmountUnit = (value, units, defaultUnit) => {
    if (!value) return { amount: '', unit: defaultUnit };
    const lastSpace = value.lastIndexOf(' ');
    if (lastSpace === -1) return { amount: value, unit: defaultUnit };
    const tail = value.slice(lastSpace + 1);
    return units.includes(tail)
        ? { amount: value.slice(0, lastSpace), unit: tail }
        : { amount: value, unit: defaultUnit };
};
